
import {ref, watch, defineComponent} from 'vue';

export default defineComponent({
  name: 'Modal',

  props: {
    id: String,         // 模态框id
    title: String,      // 对话框标题
    width: String,      // 模态框宽度
    height: String,     // 模态框高度
    modality: Boolean,  // 是否指定为模式对话框,默认false,即可通过点击遮罩层关闭
    visible: Boolean,   // 指定是否显示模态框
  },

  setup(props) {
    // 组件内部控制显示隐藏所用
    const innerVisible = ref(false);
    // 控制class,从而控制模态框内容部分动画开始
    const opened = ref(false);

    watch(() => props.visible, newValue => {
      if (newValue) {
        innerVisible.value = true;
        // 以帧动画开始显示模态框
        requestAnimationFrame(() => opened.value = true);
      } else {
        opened.value = false;
      }
    });

    return {
      innerVisible, opened,

      /**
       * 点击 遮罩层 或 关闭图标 时, 然后关闭对话框.
       *
       * @param {PointerEvent} event 点击事件
       */
      close(event: PointerEvent) {
        const classList = (event.target as HTMLElement).classList;
        // 若点击关闭图标 或 (不是模式对话框 且 点击的是遮罩层), 那么关闭对话框
        if (classList.contains('close-icon') || (!props.modality && classList.contains('modal'))) {
          // 开始动画,模态框将从当前位置开始移动直至不在可视区域内
          opened.value = false;
        }
      }
    };
  }
});
